import {
  PARTNER_WALLET_ROLES_SUCCESS,
  PARTNER_WALLET_ROLES_FAILED,
  RESET_PARTNER_WALLET_ROLES,
  LOADING_PARTNER_WALLET_ROLES,
  NETWORK_ERROR_PARTNER_WALLET_ROLES,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PARTNER_WALLET_ROLES:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case PARTNER_WALLET_ROLES_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case PARTNER_WALLET_ROLES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_PARTNER_WALLET_ROLES:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_PARTNER_WALLET_ROLES:
      return (state = initialState);
    default:
      return state;
  }
};
